import React from 'react'

const SelectInput = React.forwardRef((props, ref) => (
  <select className='filters-control' {...props} ref={ref}>
    { props.options.map((o, i) => {
      const value = Array.isArray(o) ? o[0] : o
      const label = Array.isArray(o) ? o[1] : o
      return <option key={i} value={value}>{label}</option>
    })}
  </select>
))

export default SelectInput
